export default __webpack_public_path__ + "static/media/supportIcon.cff0cb6d.svg";